import { render } from "./ContactItem.vue?vue&type=template&id=4b27317c&scoped=true"
import script from "./ContactItem.vue?vue&type=script&lang=js"
export * from "./ContactItem.vue?vue&type=script&lang=js"

import "./ContactItem.vue?vue&type=style&index=0&id=4b27317c&scoped=true&lang=scss"

import exportComponent from "/var/www/vhosts/universalmusic.fr/sites/crm/www/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b27317c"]])

export default __exports__